export default __webpack_public_path__ + "static/media/logo-ae-nike.dea3fb69.svg";